import { Route, Routes } from 'react-router-dom';

import LessonsPage from './lessons-page';

export default function Lessons() {
    return (
        <Routes>
            <Route
                path="/"
                element={<LessonsPage />}
            />
        </Routes>
    );
}